(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxDashboardEditor', {
		bindings: { dashboardId: '@' },
		controllerAs: 'vm',
		controller: MxDashboardEditorCtrl,
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-dashboard-editor/mx-dashboard-editor.html',
	});

	MxDashboardEditorCtrl.$inject = ['$scope', '$rootScope', 'mx.SolutionBuilderAgent.DashboardWidgetDataService'];

	function MxDashboardEditorCtrl($scope, $rootScope, dashboardDataService) {
		var vm = this;

		vm.dashboardDataService = dashboardDataService;
		vm.addWidgetToDashboard = addWidgetToDashboard;
		vm.resetButtonClick = resetButtonClick;
		vm.revertToCustomClick = revertToCustomClick;

		vm.$onInit = function () {
			// DashboardDataService.enableDashboardEditMode(vm.dashboardId);

			loadData();
		};

		$rootScope.$on('widgetDeleted', function (event, data) {
			if (dashboardDataService.isWidgetAvailable(vm.dashboardId, data.id)) {
				dashboardDataService.removeWidgetFromDashboard(vm.dashboardId, data.id);
				loadData();
			}
		});

		$scope.$on('$destroy', function () {
			dashboardDataService.disableDashboardEditMode(vm.dashboardId);
		});

		function sortWidgets(widgetA, widgetB) {
			if (!widgetA.added && widgetB.added) {
				return 1;
			} else if (widgetA.added && widgetB.added) {
				return 0;
			} else if (widgetA.added && !widgetB.added) {
				return -1;
			}
		}

		function loadData() {
			vm.widgets = dashboardDataService.getAvailableDashboardWidgets(vm.dashboardId);
			vm.widgets.sort(sortWidgets);
			vm.isDashboardCustomized = dashboardDataService.isDashboardCustomized(vm.dashboardId);
			vm.isCustomLayoutSaved = dashboardDataService.isCustomLayoutSaved(vm.dashboardId);
		}

		function addWidgetToDashboard(widgetId) {
			dashboardDataService.addWidgetToDashboard(vm.dashboardId, widgetId);
			loadData();
		}

		function resetButtonClick() {
			dashboardDataService.resetToDefault(vm.dashboardId);
			loadData();
			dashboardDataService.renderDashboard(vm.dashboardId);
		}

		function revertToCustomClick() {
			dashboardDataService.revertToCustomLayout(vm.dashboardId);
			loadData();
			dashboardDataService.renderDashboard(vm.dashboardId);
		}
	}
})();
